// utils/alerts.js
import Swal from "sweetalert2";
import SessionManager from "./sessionManager";
import RoutesMap from "route_control/RouteControl";

const showTokenExpiredAlert = (message, navigate) => {
    // Clear the whole session (token, user, session storage)
    SessionManager.clearAll();

    // Show popup
    Swal.fire({
        title: "Token Expired",
        text: message || "Your session has expired. Please login again.",
        icon: "error",
    }).then(() => {
        // Redirect after alert closes
        if (navigate) {
            navigate(RoutesMap.LOGIN.path);
        }
    });
};

export default showTokenExpiredAlert;